var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"cs-input",class:{
        'cs-input--error': _vm.error,
        'cs-input--disabled': _vm.disabled,
        'cs-input--correct': _vm.correct,
        'cs-input--wrong': _vm.wrong,
        'cs-input--remove-spin': _vm.removeSpin
    },attrs:{"disabled":_vm.disabled,"error":_vm.error,"type":_vm.type,"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":_vm.input,"focus":_vm.focus,"blur":_vm.blur}})}
var staticRenderFns = []

export { render, staticRenderFns }